import swal from "sweetalert";
import {
  CREATE_DOCTOR_FAIL,
  CREATE_DOCTOR_REQUEST,
  CREATE_DOCTOR_SUCCESS,
  FETCH_DOCTOR_FAIL,
  FETCH_DOCTOR_REQUEST,
  FETCH_DOCTOR_SUCCESS,
  UPDATE_DOCTOR_FAIL,
  UPDATE_DOCTOR_REQUEST,
  UPDATE_DOCTOR_SUCCESS,
} from "../../ActionType/DoctorType/DoctorType";
import { api } from "../../Api/api";
import { getToken } from "../login";
import { USER_LOGOUT_SUCCESS } from "../../ActionType/loginTypes";

export const getDcotorAction = (status,name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      status,
      name
    },
  };

  dispatch({
    type: FETCH_DOCTOR_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("doctor", config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_DOCTOR_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if(error.response.status==401){
      dispatch({
        type:USER_LOGOUT_SUCCESS
      })

      localStorage.removeItem("token")
    }
    dispatch({
      type: FETCH_DOCTOR_FAIL,
      payload: [],
    });
  }
};

export const createDcotorAction = (name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: CREATE_DOCTOR_REQUEST,
    payload: [],
  });
  try {
    const response = await api.post("doctor/create", { name }, config);
    const { status, data } = response;

    if (status == 201) {
      dispatch(getDcotorAction());
      dispatch(getDcotorAction());
      swal({
        title: "Good job!",
        text: "Doctor  was saved Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: CREATE_DOCTOR_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_DOCTOR_FAIL,
      payload: [],
    });
  }
};

export const updateDcotorAction =
  (doctor_id, name, status) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: UPDATE_DOCTOR_REQUEST,
      payload: [],
    });
    try {
      const response = await api.put(
        `doctor/update/${doctor_id}`,
        { name, status },
        config
      );
      const { data } = response;

      if (response.status == 200) {
        dispatch(getDcotorAction());
        dispatch(getDcotorAction());
        swal({
          title: "Good job!",
          text: "Doctor  was Updated Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: UPDATE_DOCTOR_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_DOCTOR_FAIL,
        payload: [],
      });
    }
  };
